export const PASSWORD_RESET_SUCCESSFULLY =
  'Your password has been reset!';
export const PHONE_VERIFICATION_ERROR =
  'This phone number does not exist!';
export const VERIFICATION_CODE_SENT =
  'Check your messages for a verification code!';
